export const downloadFile = (
  fileContent: string,
  fileName: string,
  fileType: string = "text/csv",
) => {
  const fileBlob = new Blob([fileContent], { type: fileType })
  const link = document.createElement("a")
  link.style.visibility = "hidden"
  link.href = URL.createObjectURL(fileBlob)
  link.download = fileName
  link.click()
  URL.revokeObjectURL(link.href)
}

export const downloadHref = (url: string) => {
  const link = document.createElement("a")
  link.style.visibility = "hidden"
  link.href = url
  link.target = "_blank"
  link.rel = "noopener noreferrer"
  link.click()
  link.remove()
}
